import React from 'react'

import { ReactComponent as DocumentIcon } from '@sketch/icons/document-64'
import { ReactComponent as FolderIcon } from '@sketch/icons/folder-closed-17'

import { LoadingPlaceholder } from '@sketch/components'

import { getThumbnail } from '../../../shares/ComponentsWebView/utils'

import { ImageElement } from '../../../shares/components/DocumentItem/DocumentItem.styles'
import {
  Container,
  StyledStatusIcon,
  Thumbnail,
  ThumbnailsGrid,
  NoThumbnailWrapper,
  ContainerInner,
  NoItemsIcon,
} from './NestedProjectModalPreview.styles'

import { NestedProjectFragment } from '@sketch/gql-types'
import { isTruthy } from '@sketch/utils'

export interface NestedProjectModalPreviewProps {
  className?: string
  nestedProject: Pick<NestedProjectFragment, 'name' | 'previews'>
}

export const NestedProjectModalPreview = (
  props: NestedProjectModalPreviewProps
) => {
  const { nestedProject, className } = props

  const previews = nestedProject.previews.slice(0, 4)

  return (
    <Container className={className}>
      <ContainerInner>
        {previews.length === 0 ? (
          <NoItemsIcon as={FolderIcon} aria-label="No Image available" />
        ) : (
          <ThumbnailsGrid aria-label={`Folder ${nestedProject.name}`}>
            {previews.map(({ name, file }, index) => {
              const thumbnails = (file?.thumbnails || []).filter(isTruthy)

              if (thumbnails.length === 0) {
                return (
                  <NoThumbnailWrapper key={index}>
                    <StyledStatusIcon
                      key={index}
                      as={DocumentIcon}
                      aria-label="No Image available"
                    />
                  </NoThumbnailWrapper>
                )
              } else {
                return (
                  <Thumbnail
                    key={index}
                    alt={name}
                    customImageElement={ImageElement}
                    src={getThumbnail(thumbnails)}
                    loadingPlaceholder={<LoadingPlaceholder size="17px" />}
                  />
                )
              }
            })}
          </ThumbnailsGrid>
        )}
      </ContainerInner>
    </Container>
  )
}
